import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, ref, watch } from "vue";
import "cap-widget";
import type { CapSolveEvent, CapWidget } from "cap-widget";
import { captchaApiEndpoint } from "@rmp/core/services/captcha";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpCaptcha',
  props: {
    value: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (event: "input", value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, disabled: boolean };



const captcha = ref<CapWidget | null>(null);
const state = ref<"default" | "loading" | "success" | "error">("default");
let disposed = false;

const handleReset = () => {
	if(disposed) return;
	state.value = "default";
	emit("input", "");
};

const handleError = () => {
	if(disposed) return;
	state.value = "error";
	emit("input", "");
};

const handleSolve = (event: CapSolveEvent) => {
	if(disposed) return;
	if(props.disabled) {
		captcha.value?.reset();
		return;
	}
	state.value = "success";
	emit("input", event.detail.token);
};

const verify = async () => {
	if(props.disabled || state.value === "loading" || !captcha.value) return;
	state.value = "loading";
	try {
		const result = await captcha.value.solve();
		if(!disposed && (!result?.success || !result.token)) handleError();
	} catch {
		handleError();
	}
};

watch(() => props.value, value => {
	if(!value && captcha.value?.token) captcha.value.reset();
});

onBeforeUnmount(() => {
	disposed = true;
	emit("input", "");
});

return { __sfc: true,props, emit, captcha, state, disposed, handleReset, handleError, handleSolve, verify, captchaApiEndpoint }
}

})